/* tslint:disable */

declare var Object: any;
export interface ContenedorInterface {
  "id"?: number;
}

export class Contenedor implements ContenedorInterface {
  "id": number;
  constructor(data?: ContenedorInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Contenedor`.
   */
  public static getModelName() {
    return "Contenedor";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Contenedor for dynamic purposes.
  **/
  public static factory(data: ContenedorInterface): Contenedor{
    return new Contenedor(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Contenedor',
      plural: 'Contenedors',
      path: 'Contenedors',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/lbsdk/models/Contenedor.ts